import { useContext, useEffect, useState } from 'react';
import { Portal, svgSprite } from '../../../../../../hybrid/wrappers';
import Skeleton from '../../../../../../widgets/plug/Skeleton/Skeleton';
import css from './BranchDetails.module.scss';
import { gridThead, skeletonElements, transformGridData } from './helpers';
import UserContext from '../../../../../../common/utils/getContext';
import { getData } from '../../../../../../common/utils/router';
import classNames from 'classnames';
import T from '../../../../../../common/components/T';
import GridComponent from '../../../../../../widgets/grid/GridComponent/GridComponent';

const RenderData = (props) => {
    const { gridData, setGridData, closeHandler, branch } = props;
    const titleVar =
        +branch === 1 ? (
            <T textName='left_adjective' defaultStr='левой' page='/office' />
        ) : (
            <T textName='right_adjective' defaultStr='правой' page='/office' />
        );

    return (
        <div className={css.skeletonStyles}>
            <div onClick={closeHandler} className={classNames('circleButton', css.closeModal, 'grow')}>
                {svgSprite('cross', { className: css.closeModalSvg })}
            </div>
            <p className={css.modalTitle}>
                <T
                    vars={{ titleVar }}
                    textName='scores-partner-from-branch-for-3-monthes'
                    defaultStr='Баллы партнеров из ${titleVar} ветки за 3 месяца'
                    page='/office'
                />
            </p>
            <GridComponent
                viewData={gridData.tbody}
                viewThead={gridData.thead}
                setViewData={setGridData}
                convertData={transformGridData}
                gridStyles={{
                    tableWrapper: { wrapper: css.tableWrapper },
                    sponsor: {
                        image: css.tableSponsorImage,
                        icoWrap1: css.tableUsername
                    },
                    user: { icoWrap1: css.tableUsername },
                    scores: { wrapper: css.tableScores }
                }}
            />
        </div>
    );
};

export default function BranchDetails(props) {
    const { closeHandler, branch } = props;
    const { userToken, lang } = useContext(UserContext);
    const [info, setInfo] = useState(null);
    const [gridData, setGridData] = useState(null);

    useEffect(() => {
        getData(`/api/v1/user/structure-volume-details/${branch}`, userToken, lang).then(setInfo);
    }, [userToken, lang, branch]);

    useEffect(() => {
        if (!info) return;
        setGridData({ thead: gridThead, tbody: transformGridData(info) });
    }, [info]);

    return (
        <Portal closeHandler={closeHandler}>
            <Skeleton
                wait={!!gridData}
                Component={RenderData}
                componentProps={{
                    closeHandler,
                    branch,
                    gridData,
                    setGridData
                }}
                wrapperStyles={css.skeletonStyles}
                elements={skeletonElements()}
            />
        </Portal>
    );
}
